import React from 'react';
import classNames from 'classnames';

import MessageIcon from 'icons/message-icons.svg';

interface IProps {
  title: string;
  description: string;
  showIcon?: boolean;
  className?: string;
}

export const SolutionBlockItem = ({ title, description, showIcon, className }: IProps) => {
  return (
    <div className={classNames('solution-item', className, { 'with-icon': showIcon })}>
      <div className="description">
        <h4 className="numbers no-margin-bottom">{title}</h4>
      </div>
      <span className="body-2">{description}</span>
      {showIcon && <MessageIcon className="message" />}
    </div>
  );
};
